import React from "react";
import Header from "../header/Header";
import ExploreMenus from "./exploreMenus/ExploreMenus";

const Recipes = () => {
  return (
    <>
      <Header scroll />
      <ExploreMenus />
    </>
  );
};

export default Recipes;
